import { IconBookmarkHeart, IconPercent } from 'ui-icons';

import { ThemeIcon } from '../../../../DataDisplay';
import { NumberInput } from '../../../../Inputs';
import { Group, Stack } from '../../../../Layout';
import { Text } from '../../../../Typography';
import classes from './ShopToGiveCauseAllocation.module.css';

const ShopToGiveCauseAllocation = ({
  name,
  donateText = 'Donate',
  onChange,
  value,
  icon = true,
  withBorder = true,
}: {
  name: string;
  value: number | string;
  onChange?: (split: string | number) => void;
  donateText?: string;
  icon?: boolean;
  withBorder?: boolean;
}) => {
  return (
    <Stack
      pb={'sm'}
      gap={'sm'}
      className={classes.shopToGiveCauseAllocation}
      mod={{ 'with-border': withBorder }}
    >
      <Group gap="xs">
        {icon && (
          <ThemeIcon c="yellow" size={20} variant={'transparent'}>
            <IconBookmarkHeart />
          </ThemeIcon>
        )}
        <Text c="gray.8" fw={500}>
          {name}
        </Text>
      </Group>

      <Group gap={'sm'}>
        <Text fz={12} fw={400} c="gray" w={44}>
          {donateText}
        </Text>
        <NumberInput
          w={72}
          value={value}
          onChange={onChange}
          disabled={!onChange}
          rightSection={<IconPercent />}
          max={100}
        />
        <Text fz={12} fw={400} c="gray">
          of my cash back
        </Text>
      </Group>
    </Stack>
  );
};

export { ShopToGiveCauseAllocation };
